import { Href } from 'expo-router';

const nonHeaderRoutes: Href[] = [
  '/privacyPolicy',
  '/termsOfService',
  '/notifications',
  '/profile/settings',
  '/profile/settings/preferences',
  '/profile/settings/changePassword',
  '/profile/settings/editRange',
  '/profile/settings/editName',
  '/profile/settings/favorites',
  '/profile/settings/transactions',
  '/profile/settings/subscriptions',
  '/profile/settings/faq',
  '/profile/individual/edit',
  '/profile/individual/impact/period/monthImpact',
  '/profile/individual/impact/period/yearImpact',
  '/profile/individual/impact/period/allTimeImpact',
  '/profile/individual/impact/map',
  '/edit/editOneProgram',
  '/edit/npoBioWiki',
  '/edit/npoGeneral',
  '/edit/npoRevenue',
  '/edit/npoRevenueWiki',
  '/edit/npoTotalSalaries',
  '/edit/npoFundraising',
  '/edit/npoLandEquipments',
  '/edit/npoSalaries',
  '/edit/addUpdateSalary',
  '/edit/npoBoardDirectors',
  '/edit/npoPastors',
  '/edit/addUpdateDirector',
  '/edit/addUpdatePastor',
  '/edit/npoBackgroundChecks',
  '/edit/npoPL',
  '/edit/npoPLWiki',
  '/edit/npoImpactStudy',
  '/edit/npoPrograms',
  '/edit/addUpdateProgram',
  '/edit/npoPartyAudit',
  '/edit/npoTotalGrantsPrograms',
  '/edit/npoLightRatingQuestions',
  '/edit/npoVolunteerEvent',
  '/edit/addUpdateTotalGrantProgram',
  '/create/amenities',
  '/create/addUpdateAmenity',
  '/create/program',
  '/create/volunteerEvent',
  '/questions/ask_question',
  '/questions/add_question_answer',
  '/questions/list/[npoId]',
  '/paymentMethods',
  '/paymentMethods/addAch',
  '/paymentMethods/addCreditCard',
  '/paymentMethods/creditCardList',
  '/paymentMethods/achList',
  '/paymentMethods/billingAddress',
  '/donationPayment',
  '/npoPaymentOnboarding/npoPaymentOnboardingIntro',
  '/npoPaymentOnboarding/achTerms',
  '/npoPaymentOnboarding/bankAccount',
  '/npoPaymentOnboarding/documents',
  '/npoPaymentOnboarding/general',
  '/npoPaymentOnboarding',
  '/npoPaymentOnboarding/owner',
  '/npoPaymentOnboarding/riskProfile',
  '/donationPayment/editSubscription',
  '/programDetail/[programId]',
  '/messages',
  '/messages/userNpo/[userId]',
  '/messages/[volunteerEventId]',
  '/messages/npoDonations/[npoId]',
  '/claimNpo',
  '/muxPlayer',
  '/show',
  '/show/[episodeId]',
  '/show/giftSeries',
  '/show/giftSummary',
  '/profile/settings/giftsList',
  '/purchaseShow',
  '/confirmPurchaseShow',
  '/confirmPurchaseGifts'
];

export default nonHeaderRoutes;
